import React from 'react';
import { DividedTabSection } from '../TabSections';
import { SECTIONS } from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.PARKING_FEES;

const ParkingFees = () => {
  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      {/* TODO - remove TITLE placeholder with section content */}
      <div>{TITLE}</div>
    </DividedTabSection>
  );
};

export default ParkingFees;
